import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { hideRemoveDatasetCondition, removeDatasetCondition } from '../actions';

const DatasetConditionDeletionDialog = ({
  deleteData,
  hide,
  name,
  results,
  theme,
}) => (
  <ActionDialogContent
    className="aridhia-dataset-conditions-deletion-dialog"
    entities="dataset.conditions"
    entity="dataset.condition"
    hide={hide}
    identifiers={['condition.code']}
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    items={results}
    onSubmit={({ items }) => deleteData(name, items)}
    simple
    theme={theme}
  />
);

const mapStateToProps = ({
  datasetConditions: { datasetConditions: { deletion: { name, results } } },
}) => ({ name, results });

const mapDispatchToProps = {
  hide: hideRemoveDatasetCondition,
  deleteData: removeDatasetCondition,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetConditionDeletionDialog);
